import config from "../config";
import * as url from "../helpers/url_helper";
import { getResourceStore } from "./crudFactory";

/**
 * 稽核保留區（ticket 08）。
 *
 * 刪除核准後,資料不是消失而是搬到這裡:需求書要求留存以備稽核查詢,
 * 「已經刪掉、查不到了」在稽核時是交代不過去的答案。
 * 保留期限跟審核紀錄一樣是 180 天(正式版由後端排程清理)。
 */
const RETAIN_DAYS = 180;

const latency = () => config.MOCK_LATENCY;
const reply = (status, body) =>
  new Promise((resolve) => setTimeout(() => resolve([status, body]), latency()));

let archive = [];
let seq = 1;

/** 把某筆資料從它的資源移出來、整筆存進保留區 */
export function archiveRecord({ resource, recordId, approvalId, by }) {
  const store = getResourceStore(resource);
  if (!store) return null;
  const record = store.find(recordId);
  if (!record) return null;

  const now = Date.now();
  const entry = {
    id: seq++,
    resource,
    recordId,
    record: { ...record }, // 整筆留著 —— 只留 id 的話稽核什麼都查不到
    approvalId,
    deletedBy: by || "",
    deletedAt: new Date(now).toISOString(),
    retainUntil: new Date(now + RETAIN_DAYS * 24 * 60 * 60 * 1000).toISOString(),
  };
  archive.push(entry);
  store.remove(recordId);
  return entry;
}

/**
 * 種一筆「已廢除」示例(WF_v3 票 21):不經審核流程、不動資源 store,
 * 讓「顯示已廢除資料」開關在乾淨 demo 環境也看得到東西。
 * 只在 setupMock 註冊完呼叫;record 整筆給,shape 同該資源的種子列。
 */
export function seedArchiveEntry({ resource, record, deletedBy = "", deletedAt }) {
  const at = deletedAt ? new Date(deletedAt).getTime() : Date.now();
  const entry = {
    id: seq++,
    resource,
    recordId: record.id,
    record: { ...record },
    approvalId: null,
    deletedBy,
    deletedAt: new Date(at).toISOString(),
    retainUntil: new Date(at + RETAIN_DAYS * 24 * 60 * 60 * 1000).toISOString(),
  };
  archive.push(entry);
  return entry;
}

export default function registerAuditArchive(mock) {
  // setupMock 會重新註冊 = 重建 mock 世界
  archive = [];
  seq = 1;

  mock.onGet(url.DCK.AUDIT_ARCHIVE).reply((cfg) => {
    const params = cfg.params || {};
    let rows = archive.slice();
    if (params.resource) rows = rows.filter((r) => r.resource === params.resource);
    const page = Number(params.page) || 1;
    const pageSize = Number(params.pageSize) || 10;
    const start = (page - 1) * pageSize;
    return reply(200, {
      data: rows.slice(start, start + pageSize),
      total: rows.length,
      page,
      pageSize,
    });
  });
}
